import Vue from 'vue';
import Notifications from 'vue-notification';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueMaterial from 'vue-material';
import VuejsDialog from 'vuejs-dialog'; //https://github.com/godofbrowser/vuejs-dialog
import { Mixin } from 'sr-js-lib';
import i18n from './i18n';
import App from './App.vue';
import router from './router';
import store from './store';
import './plugins/vee-validate';
import './registerServiceWorker'

import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import 'bootstrap/dist/css/bootstrap.css'

const url = new URL(window.location.href);
const stayDesktopVersion = url.searchParams.get('stay-desktop-version')
  ? url.searchParams.get('stay-desktop-version') : localStorage.getItem('stayDesktopVersion');

localStorage.setItem('stayDesktopVersion', true);

let defaultLanguage = process.env.VUE_APP_LOCALE;
if (store.state && store.state.user && store.state.user.language) {
  defaultLanguage = store.state.user.language;
  i18n.locale = defaultLanguage;
}

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(Notifications);
Vue.use(VueMaterial);
Vue.use(VuejsDialog);


Vue.mixin(Mixin);
Mixin.methods.F_init({
  store: (field) => {
    return store.state[field];
  },
  language: defaultLanguage,
  translate: (key) => {
    return i18n.t(key);
  }
});

const VUE_APP = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
});
VUE_APP.$mount('#app');
Mixin.data().consts.Context.APP = VUE_APP;
